export default {
  devices: [],
  allDevices: [],
  isInitialized: false,
  error: null,
  isLoading: false,
};
